export type AnalyticsEventName =
  | 'signup'
  | 'first_ad_generated'
  | 'credits_used'
  | 'upgrade_clicked'
  | 'quick_start_opened'
  | 'quick_start_generated'
  | 'quick_start_anonymous_generation_attempted'
  | 'quick_start_signup_prompt_shown'
  | 'quick_start_signup_clicked'
  | 'second_variation_clicked'
  | 'upgrade_prompt_shown'
  | 'save_clicked'
  | 'export_clicked'
  | 'repeat_generation_session';

export type AnalyticsProperties = Record<string, string | number | boolean | null | undefined>;

export function trackEvent(name: AnalyticsEventName, properties: AnalyticsProperties = {}) {
  const payload = {
    name,
    properties,
    timestamp: new Date().toISOString(),
  };

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('adforge:analytics', { detail: payload }));
  }

  if (import.meta.env.DEV) {
    console.info('[analytics]', payload);
  }
}
